export class OrderApprovalDto {
  id = 0;
  orderId = 0;
  accountOwner: string | null = null;
  isMultiYearInProcess = false;
  isAlreadyApproved = false;
}
